import { Message } from 'view-design'

export default function({ $axios, redirect, app, $config }) {
    $axios.defaults.timeout = 60000
    $axios.onRequest(config => {
        config.headers = {
            area_code: $config.AREA_CODE
        }
        // console.log(config)
        // config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });
        return config
    })

    $axios.onResponse(response => {
        // console.log(response)
        // console.log(response.config.url)
        // console.log(response)
    })

    $axios.onError(error => {
        console.log(error)
        const code = parseInt(error.response && error.response.status)
        if (code == 400) {
            Message.error(error.response.data)
        }
    })
}
